import { FC } from 'react';

import { AccountSettings } from '@shared/components/AccountSettings';

export const GiftSellerSettingsPage: FC = function GiftSellerSettingsPage() {
  return <AccountSettings heading="계정정보" />;
};
